import React from 'react';
import Box from '@mui/material/Box';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

export interface FormActionsProps {
  onSubmit?: () => void;
  onCancel?: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  submitDisabled?: boolean;
  loading?: boolean;
  children?: React.ReactNode;
}

const FormActions: React.FC<FormActionsProps> = ({
  onSubmit,
  onCancel,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  submitDisabled = false,
  loading = false,
  children,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1.5,
        pt: 2,
      }}
    >
      {children}
      {onCancel && (
        <SecondaryButton onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </SecondaryButton>
      )}
      {onSubmit && (
        <PrimaryButton
          onClick={onSubmit}
          disabled={submitDisabled}
          loading={loading}
        >
          {submitLabel}
        </PrimaryButton>
      )}
    </Box>
  );
};

export default FormActions;
